import {
  Badge,
  Box,
  Card,
  CardBody,
  Checkbox,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Input,
  Select,
  Text,
  VStack,
} from "@chakra-ui/react";

const MECHANISM_BADGE = {
  tool: { label: "in-call tool", color: "blue" },
  contact_sync: { label: "save contact", color: "purple" },
  conversation_sync: { label: "save transcript", color: "purple" },
  summary_email: { label: "email", color: "teal" },
  webhook: { label: "webhook", color: "orange" },
};

const CRM_CHOICES = [
  { value: "hubspot", label: "HubSpot" },
  { value: "zoho", label: "Zoho CRM" },
  { value: "gohighlevel", label: "GoHighLevel" },
];

export default function Step4Outcomes({
  config,
  outcomeSelections,
  onToggleOutcome,
  crmChoice,
  onCrmChoice,
  summaryEmail,
  onSummaryEmail,
  webhookUrl,
  onWebhookUrl,
}) {
  if (!config) return <Text>Pick a use case first.</Text>;

  const outcomes = config.recommended_outcomes || [];
  const anyCrmOutcome = outcomes.some(
    (o) =>
      outcomeSelections[o.key] &&
      o.tool_key === "crm_picker" &&
      (o.mechanism === "contact_sync" || o.mechanism === "conversation_sync")
  );
  const summaryOn = outcomes.some(
    (o) => outcomeSelections[o.key] && o.mechanism === "summary_email"
  );
  const webhookOn = outcomes.some(
    (o) => outcomeSelections[o.key] && o.mechanism === "webhook"
  );

  return (
    <VStack spacing={6} align="stretch">
      <VStack spacing={1} textAlign="center">
        <Heading size="lg">What happens after?</Heading>
        <Text color="gray.600">
          Pick what your agent should do when it succeeds.
        </Text>
      </VStack>

      <VStack spacing={3} align="stretch">
        {outcomes.map((o) => {
          const badge = MECHANISM_BADGE[o.mechanism];
          const checked = !!outcomeSelections[o.key];
          return (
            <Card
              key={o.key}
              borderWidth="1px"
              borderColor={checked ? "blue.300" : "gray.200"}
              bg={checked ? "blue.50" : "white"}
            >
              <CardBody py={3}>
                <Checkbox
                  isChecked={checked}
                  onChange={(e) => onToggleOutcome(o.key, e.target.checked)}
                >
                  <HStack ml={2}>
                    <Text fontWeight="medium">{o.label}</Text>
                    {badge && (
                      <Badge colorScheme={badge.color} fontSize="0.65rem">
                        {badge.label}
                      </Badge>
                    )}
                  </HStack>
                </Checkbox>
              </CardBody>
            </Card>
          );
        })}
      </VStack>

      {anyCrmOutcome && (
        <Box bg="purple.50" borderRadius="md" p={4}>
          <FormControl>
            <FormLabel fontSize="sm">Which CRM?</FormLabel>
            <Select
              value={crmChoice || ""}
              placeholder="Pick a CRM"
              onChange={(e) => onCrmChoice(e.target.value)}
              bg="white"
            >
              {CRM_CHOICES.map((c) => (
                <option key={c.value} value={c.value}>
                  {c.label}
                </option>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}

      {summaryOn && (
        <Box bg="teal.50" borderRadius="md" p={4}>
          <FormControl>
            <FormLabel fontSize="sm">Email summaries to</FormLabel>
            <Input
              type="email"
              placeholder="you@yourcompany.com"
              value={summaryEmail || ""}
              onChange={(e) => onSummaryEmail(e.target.value)}
              bg="white"
            />
          </FormControl>
        </Box>
      )}

      {webhookOn && (
        <Box bg="orange.50" borderRadius="md" p={4}>
          <FormControl>
            <FormLabel fontSize="sm">Webhook endpoint</FormLabel>
            <Input
              type="url"
              placeholder="https://your-app.com/webhooks/insighto"
              value={webhookUrl || ""}
              onChange={(e) => onWebhookUrl(e.target.value)}
              bg="white"
            />
            <Text fontSize="xs" color="gray.500" mt={1}>
              We'll POST to this URL when a conversation closes.
            </Text>
          </FormControl>
        </Box>
      )}
    </VStack>
  );
}
